import {
    FETCH_DATA_ANNOUNCEMENTS_REQUEST,
    FETCH_DATA_ANNOUNCEMENTS_SUCCESS,
    FETCH_DATA_ANNOUNCEMENTS_FAILURE,
} from '../../actions/announcement/get-announcements-actions';

const initialState = {
    list: [],
    isLoading: false,
    error: null,
    meta: null
};

const AnnouncementReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DATA_ANNOUNCEMENTS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DATA_ANNOUNCEMENTS_SUCCESS:

        console.log("action.payload.values",  action.payload.values);
            return {
                ...state,
                isLoading: false,
                list: action.payload.values,
                meta: action.payload.meta
            };
        case FETCH_DATA_ANNOUNCEMENTS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default AnnouncementReducer;